"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GmailConnectRequest = exports.PBRAuthResponse = exports.PBRGmailAuthRequest = void 0;
const zod_1 = require("zod");
exports.PBRGmailAuthRequest = zod_1.z.object({
    authorizationCode: zod_1.z.string(),
    country: zod_1.z.string().nullable(),
    signUpIPCountry: zod_1.z.string().nullable(),
    platform: zod_1.z.string(),
    IPAddress: zod_1.z.string().nullable(),
    referrerId: zod_1.z.string().nullable(),
    signupAttr: zod_1.z.string().nullable(),
    redirectUri: zod_1.z.string(),
    scopes: zod_1.z.string().optional(),
});
exports.PBRAuthResponse = zod_1.z.object({
    accessToken: zod_1.z.string(),
    type: zod_1.z.string(),
});
exports.GmailConnectRequest = zod_1.z.object({
    authorizationCode: zod_1.z.string(),
    userId: zod_1.z.string(),
    redirectUri: zod_1.z.string(),
    shouldOpenModal: zod_1.z.boolean().optional(),
});
